module.exports = __webpack_public_path__ + "static/media/main idea.d2238873.mp3";